<template>
  <form id="frm_action">
    <div class="p-formgrid p-grid">
      <div class="col-6 box-form" >
        <div class=" form-stack" style="background-color: rgb(255, 255, 255); border-radius: 8px; padding: 20px; box-sizing: border-box; box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 10px;">
        <div class=" p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Vehicle Category</label>
          <div class="p-col">
            <v-select :clearable="false" placeholder="Choose" v-model="obj_data.vehicle_category_id"
              :options="ListvehicleCategory" :reduce="item => item.id" label="name">
              <span slot="no-options" @click="$refs.select.open = false">Empty data</span>
            </v-select>
            <input class="input_tmp_validator" id="vehicle_category_id">
          </div>
        </div>


        <!-- Car Status -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Car status</label>
          <div class="p-col">
            <v-select :clearable="false" title="Car Status" placeholder="Choose" v-model="obj_data.status"
              :options="$constants.CAR_FOR_RENT_STATUS" :reduce="item => item.value" label="label">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="status">
          </div>
        </div>

        <div class="p-card-field" v-if="obj_data.status == 'FIXING_RENT'">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Fee fix</label>
          <div class="p-col">
             <InputNumber
                  id="fee_fix"
                  placeholder="Input"
                  v-model="obj_data.fee_fix"
                  mode="decimal"
                  :minFractionDigits="2"
              />
          </div>
        </div>

        <!-- License Plate Number -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">License plate number</label>
          <div class="p-col">
            <InputText v-model="obj_data.license_plate_number" placeholder="AO-31-BE" id="license_plate_number" />
          </div>
        </div>

        <!-- Valid Until -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Valid until</label>
          <div class="p-col">
            <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true" :minDate="new Date()"
              :manualInput="false" v-model="obj_data.valid_until" placeholder="DD/MM/YYYY" id="valid_until" />
          </div>
        </div>

        <!-- Color -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right txt-required">Color</label>
          <div class="p-col">
            <InputText v-model="obj_data.color" placeholder="Input" id="color" />
          </div>
        </div>

        <!-- Active -->
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>

        <!-- Buttons -->
        <Toolbar class="fixed-bottom-toolbar div-button">
          <template slot="right">
            <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
            <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
              class="main-style-button" />
            <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
          </template>
        </Toolbar>
        </div>
      </div>
      <div class="col-6" v-if="car_for_rent_id">
 <LogHistory :log_type="'car_for_rent'" :object_id="car_for_rent_id" /> 
      </div>

      
    </div>
  </form>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import LogHistory from "@/components/LogHistory.vue";
//this.$AuthenticationApp.getStateLoginNew
export default {
  props: {
    mode: String,
    model: Object,
  },
  components: {
 LogHistory,
    
  },
  data() {
    return {
      showDeleteDialog: false,
      ListvehicleCategory: [],
      listRentalOrder: [],
      rentalOrder: [],
      obj_data: {
        active: true,
      },
      car_for_rent_id:null,
      

    };
  },
  async mounted() {
    
    this.car_for_rent_id = this.$route.params?.id ?? null
    await this.getLisRentalOrder();
    await this.getLisVehicleCategory();
    if (this.model && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      console.log('this.obj_data', this.obj_data);
      this.obj_data.valid_until = this.formatDate(this.obj_data.valid_until);
      //  CAR_FOR_RENT_STATUS.find(s => s.value === statusValue)?.label ?? '';
       //this.obj_data.status = this.$constants.CAR_FOR_RENT_STATUS.find(s => s.value === this.obj_data.status)?.label ?? '';
      // if (this.obj_data.status === 'AVAILABLE_RENT') {
      //   this.obj_data.status = 'Available';
      // } else if (this.obj_data.status === 'RENTING_RENT') {
      //   this.obj_data.status = 'Renting';
      // } else if (this.obj_data.status === 'NEEDS_INSPECTION_RENT') {
      //   this.obj_data.status = 'Needs inspection';
      // } else if (this.obj_data.status === 'REVIEWING_RENT') {
      //   this.obj_data.status = 'Reviewing';
      // } else if (this.obj_data.status === 'EXPIRED_RENT') {
      //   this.obj_data.status = 'Expired';
      // } else if (this.obj_data.status === 'CLEAN_RENT') {
      //   this.obj_data.status = 'Clean';
      // }


    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
  
      return `${day}/${month}/${year}`;
    },
    async getLisVehicleCategory() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        if (list && list.list) {
          this.ListvehicleCategory = list.list;
        } else {
          console.log('No data returned');
        }

      } catch (error) {
        console.error('Error loading vehicle categories:', error);
      }
    },
    async getLisRentalOrder() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisRentalOrder(where_key);
        if (list && list.list) {
          this.listRentalOrder = list.list.map(order => ({
            id: order.id,
            code: order.code
          }));
        }
      } catch (error) {
        console.error('Error loading rental orders:', error);
      }
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};

      const fieldsToValidate = [
        { id: "vehicle_category_id", value: this.obj_data.vehicle_category_id },
        { id: "status", value: this.obj_data.status },
        { id: "license_plate_number", value: this.obj_data.license_plate_number },
        { id: "color", value: this.obj_data.color }
      ];
      // if(this.obj_data.status == 'FIXING_RENT'){
      //   fieldsToValidate.push({ id: "fee_fix", value: this.obj_data.fee_fix })
      // }

      let isFormInvalid = false;

      fieldsToValidate.forEach(field => {
        let inputElement = document.getElementById(field.id);

        if (inputElement && ["INPUT", "TEXTAREA", "SELECT"].includes(inputElement.tagName)) {
          if (!field.value || this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      });

      let inpObj = document.getElementById("frm_action");
      if (inpObj && (!inpObj.checkValidity() || isFormInvalid)) {
        inpObj.reportValidity();
        return true;
      }

      return false;
    },
    async checkExistCategory(){
      // if(this.email !== null && this.email !== ''){
      var where = {
        deleted: {'_eq': false},
        vehicle_category_id: {'_eq': this.obj_data.vehicle_category_id}
      }
      if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
      var {data} = await this.$apollo.query({
        query: DataServices.getList('car_for_rent', {"fields" : "id, vehicle_category_id"}),
        variables: {
          where_key: where
        },
        fetchPolicy: "network-only"
      })
      // console.log(data)
      return data && data[Object.keys(data)].length > 0
      //}
    },
    async saveData() {
      this.$commonFuction.is_loading(true);

      // Kiểm tra validate
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return; // Dừng nếu có lỗi
      }
      // if(await this.checkExistCategory()){
      //   this.$commonFuction.is_loading(false);
      //   //tiếng anh
      //   alert('Vehicle category already exists');
      //   return;
      // }
      var  params = this.obj_data;
      if (params.valid_until instanceof Date) {
        // Nếu valid_until là đối tượng Date, định dạng lại
        params.valid_until = moment(params.valid_until).format('YYYY-MM-DD');
      } else if (typeof params.valid_until === 'string') {
        // Nếu valid_until là chuỗi "dd/MM/yyyy", chuyển thành định dạng YYYY-MM-DD
        const regoDate = moment(params.valid_until, 'DD/MM/YYYY');
        params.valid_until = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
      }
      // Nếu không có lỗi, thực hiện lưu dữ liệu
      console.log('_____________', this.obj_data);


      // kiểm tra nếu this.obj_data.status là object thì chuyển thành truy xuất lấy value
      if (typeof this.obj_data.status === 'object') {
        this.obj_data.status = this.obj_data.status.value;
      }
      this.$emit('save', this.obj_data);
    }


    ,
  },
};

</script>
<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}

.service--product .vs__dropdown-toggle {
  height: 48px;
}

.class-bold1 {
  font-weight: bold;
}



.p-button-outlined .p-button-label {
    color: #000000 !important;
}

.box-form {
  // background-color: #ffffff;
  // border-radius: 8px;
  // padding: 20px;
  // box-sizing: border-box;
  // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-stack {
  display: flex;
  flex-direction: column;
  gap: 14px; /* dãn đều */
}

</style>
